import { html, css } from "lit";
import { SignalWatcher } from "@lit-labs/preact-signals";
import { DsfNavbarItem } from "../NavbarItem/index.js";
import "../../atom/ModalBase/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { rif } from "../../../helpers/renderIf.js";
import { isMobile, mediaQueries } from "../../../responsive/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfSubmenu = class extends SignalWatcher(BaseComponent) {
  async handleSlotChange() {
    await this.updateChildren();
  }
  async updateChildren(children = this.children) {
    await this.updateComplete;
    Array.from(children).filter((child) => child instanceof DsfNavbarItem).forEach(async (child) => {
      const navbarItem = child;
      navbarItem.dsf_submenu = true;
      if (navbarItem.children.length > 0) {
        await this.updateChildren(navbarItem.children);
      }
    });
  }
  render() {
    const submenu = html`<div
      class="flex min-w-200 flex-auto flex-col gap-10 overflow-y-auto bg-neutral-50 p-16 mobile:h-screen"
      part="content"
    >
      ${rif(
      this.dsf_title,
      html`<span class="dsf-text-xs mb-12 text-neutral-400" data-skeleton
          >${this.dsf_title}</span
        >`
    )}
      <slot @slotchange=${this.handleSlotChange}></slot>
    </div>`;
    return isMobile() ? html`<dsf-modal-base> ${submenu} </dsf-modal-base>` : submenu;
  }
};
DsfSubmenu.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
DsfSubmenu.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        width: fit-content;
      }
    `,
  mediaQueries.mobile.down(css`
      dsf-modal-base::part(overlay) {
        align-items: flex-start;
        justify-content: flex-start;
      }
      dsf-modal-base::part(modal) {
        width: fit-content;
      }
    `)
];
__decorateClass([
  prop({ type: String })
], DsfSubmenu.prototype, "dsf_title", 2);
DsfSubmenu = __decorateClass([
  defineElement("dsf-submenu")
], DsfSubmenu);
export {
  DsfSubmenu
};
